import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
import { Breadcrumbs } from "../../../AbstractElements";
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import ImageSlider from "../../Components/product/ImageSilder";
import ProductDetails from "../../Components/product/ProductDetails";

export const DatailProduct = () => {
  const { id } = useParams();
  const { getData } = useDataFetch();

  const { data: productData, isLoading } = getData(["product", id], `/product/${id}`, {
    enabled: !!id,
  });

  const product = productData?.product;

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <Spinner color="primary" /> Cargando producto...
      </div>
    );
  }

  if (!product) {
    return (
      <div className="text-center py-5">
        <h5>No se encontró el producto</h5>
      </div>
    );
  }

  return (
    <Fragment>
      <Breadcrumbs parent="Ecommerce" title="Detalle Producto" mainTitle="Detalle Producto" />
      <Container fluid={true}>
        <Row className="product-page-main p-0">
          {/* Imagen Slider */}
          <Col xxl="4" md="6" className="box-col-12">
            <Card>
              <CardBody>
                <ImageSlider images={product.images} mainImage={product.mainImage} />
              </CardBody>
            </Card>
          </Col>

          {/* Detalles */}
          <ProductDetails product={product} />
        </Row>
      </Container>
    </Fragment>
  );
};
